import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Réinitialise la position de scroll en haut à chaque changement de route.
 * Respecte les ancres #hash (ne scrolle pas si un hash est présent dans l'URL).
 * Retire le focus résiduel du CTA cliqué (sinon le navigateur le ramène dans la
 * vue ~100ms après le reset, décalant la page de ~140-170px).
 * Rendu null : composant purement comportemental, placé sous le Router.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Laisser le navigateur gérer le défilement vers l'ancre si présente.
    if (hash) return;

    // L'élément cliqué (lien/bouton) garde le focus après une navigation SPA :
    // le navigateur le re-scrolle dans la vue après coup. On retire ce focus.
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement && activeElement !== document.body) {
      activeElement.blur();
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

    // Second passage après le paint pour neutraliser un repositionnement tardif.
    const frame = window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    });

    return () => window.cancelAnimationFrame(frame);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
